import React from 'react';

import cn from 'classnames';

import { CustomModal, UiButton, UiText } from '@shared/ui';

import cls from './PresentationModal.module.css';
import { usePresentationModal } from '../lib/hooks/usePresentationModal';

interface PresentationModalProps {
    classes?: string;
    videoSrc?: string;
    header?: string;
    subHeader?: string;
    onClosePresentation?: () => void;
    isOpen: boolean;
    tariffQuery?: string;
}

export const PresentationModal = ({
    classes,
    subHeader = '',
    header = '',
    videoSrc = '',
    onClosePresentation,
    isOpen,
    tariffQuery = '',
}: PresentationModalProps) => {
    const { hideModal, changeTariff, t } = usePresentationModal(onClosePresentation, tariffQuery);

    return (
        <CustomModal
            onHideModal={hideModal}
            isOpen={isOpen}
            classes={cn(cls.PresentationModal, [classes])}
            closeButtonClass={cls.CloseBtn}
        >
            <CustomModal.Header>
                <div className={cls.heder}>
                    {header}
                    <UiText classes={cls.subHeader} variant="plain">
                        {subHeader}
                    </UiText>
                </div>
            </CustomModal.Header>
            <CustomModal.Body width="548px">
                <div className={cls.video}>
                    {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                    <iframe src={videoSrc} />
                </div>
            </CustomModal.Body>
            <CustomModal.Footer>
                <div className={cls.footer}>
                    <UiButton
                        onClick={changeTariff}
                        btnText={t(
                            'PresentationModal.return.CustomModal.Footer.changeTariff.btnText'
                        )}
                    />
                    <a target="_blank" href="//smetter.ru/tariffs" rel="noreferrer">
                        {t('PresentationModal.return.CustomModal.Footer.a')}
                    </a>
                </div>
            </CustomModal.Footer>
        </CustomModal>
    );
};
